import { render, staticRenderFns } from "./CreateNote.vue?vue&type=template&id=2b57ca30&scoped=true&lang=html&"
import script from "./CreateNote.vue?vue&type=script&lang=js&"
export * from "./CreateNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57ca30",
  null
  
)

export default component.exports